import React from 'react';

// TODO Delete when cleaning fg('bandicoots-update-sllv-icons')
export var CrystalBallSVGOld = function CrystalBallSVGOld() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "140",
    height: "140",
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1944_97883)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "140",
    height: "140",
    fill: "white",
    fillOpacity: "0.01"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "0.5",
    d: "M70 140C108.66 140 140 108.66 140 70C140 31.3401 108.66 0 70 0C31.3401 0 0 31.3401 0 70C0 108.66 31.3401 140 70 140Z",
    fill: "url(#paint0_linear_1944_97883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.45 82.9046C134.964 51.1191 115.287 19.2607 83.5018 11.7469C51.7163 4.23312 19.8579 23.9093 12.3442 55.6948C4.83038 87.4803 24.5065 119.339 56.292 126.852C88.0776 134.366 119.936 114.69 127.45 82.9046Z",
    fill: "url(#paint1_linear_1944_97883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8802 123.41C99.8062 123.41 124.066 99.1504 124.066 69.2244C124.066 39.2984 99.8062 15.0386 69.8802 15.0386C39.9542 15.0386 15.6943 39.2984 15.6943 69.2244C15.6943 99.1504 39.9542 123.41 69.8802 123.41Z",
    fill: "url(#paint2_linear_1944_97883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6137 86.5307C63.5541 85.2775 63.4347 84.263 63.4347 82.9501C63.4347 77.2212 65.6427 72.5665 71.1329 68.6279L75.4893 65.4651C78.5924 63.1974 79.965 60.4523 79.965 57.2298C79.965 52.2767 76.6231 47.6219 69.7007 47.6219C62.7783 47.6219 58.959 53.0525 58.959 58.4233C58.9517 59.8767 59.1527 61.3236 59.5558 62.72L48.8141 61.9442C48.4449 60.5219 48.2644 59.0572 48.277 57.5878C48.277 48.0993 55.3784 37.7754 69.7007 37.7754C84.0229 37.7754 91.3631 47.0849 91.3631 56.7524C91.3631 64.2119 87.3648 69.5827 81.8746 73.4617L77.757 76.2664C76.2841 77.2583 75.0817 78.6016 74.2586 80.1749C73.4354 81.7483 73.0175 83.502 73.0425 85.2775C73.0389 85.696 73.0588 86.1144 73.1022 86.5307H63.6137ZM68.4475 93.1548C70.2943 93.1861 72.0549 93.9418 73.3498 95.259C74.6447 96.5762 75.3702 98.3494 75.3699 100.197C75.3464 101.56 74.9205 102.887 74.1457 104.009C73.3709 105.132 72.2817 106.001 71.0149 106.506C69.7481 107.012 68.3602 107.132 67.0253 106.852C65.6905 106.571 64.4682 105.903 63.512 104.93C62.5558 103.957 61.9082 102.724 61.6506 101.384C61.3931 100.045 61.5369 98.6592 62.0642 97.4012C62.5915 96.1433 63.4786 95.0691 64.6143 94.3136C65.7499 93.5581 67.0835 93.155 68.4475 93.1548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4456 97.7493C50.8437 89.0366 67.6723 89.693 79.1898 99.838C79.7269 96.6155 81.0398 91.9607 84.5606 88.0818C91.125 80.9803 100.315 81.6368 106.879 79.6675C112.191 78.0562 118.218 73.9386 123.827 64.092C122.868 53.8027 118.974 44.0054 112.608 35.8652C111.299 36.6784 109.944 37.4156 108.55 38.0732C97.8087 43.2054 89.6928 41.6538 82.9494 48.5166C77.9366 53.6487 76.6237 60.5114 76.206 65.2855C72.515 64.2895 68.6286 64.269 64.9272 65.2259C53.4694 68.2693 50.605 80.0852 39.3859 91.1849C35.4427 95.102 30.9618 98.4375 26.0781 101.091C27.6654 103.293 29.4212 105.368 31.3296 107.297C33.3068 103.561 36.0768 100.303 39.4456 97.7493Z",
    fill: "url(#paint3_linear_1944_97883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.827 64.0923C118.217 73.9388 112.19 78.0565 106.879 79.6677C100.315 81.637 91.1245 80.9806 84.5601 88.0821C81.0392 91.961 79.7264 96.6157 79.1893 99.8382C67.6718 89.6933 50.8432 89.0369 39.445 97.7496C36.0762 100.303 33.3063 103.562 31.3291 107.298C38.88 114.942 48.5331 120.169 59.0618 122.315C69.5905 124.46 80.5193 123.426 90.4591 119.345C100.399 115.265 108.901 108.321 114.885 99.3961C120.869 90.4715 124.065 79.9694 124.066 69.2244C124.077 67.5107 123.997 65.7976 123.827 64.0923Z",
    fill: "url(#paint4_linear_1944_97883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.827 64.0923C118.217 73.9388 112.19 78.0565 106.879 79.6677C100.315 81.637 91.1245 80.9806 84.5601 88.0821C81.0392 91.961 79.7264 96.6157 79.1893 99.8382C67.6718 89.6933 50.8432 89.0369 39.445 97.7496C36.0762 100.303 33.3063 103.562 31.3291 107.298C38.88 114.942 48.5331 120.169 59.0618 122.315C69.5905 124.46 80.5193 123.426 90.4591 119.345C100.399 115.265 108.901 108.321 114.885 99.3961C120.869 90.4715 124.065 79.9694 124.066 69.2244C124.077 67.5107 123.997 65.7976 123.827 64.0923Z",
    fill: "url(#paint5_linear_1944_97883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4359 85.9934C31.389 81.9951 37.5356 79.3694 40.1614 72.447C42.7871 65.5245 40.6985 59.2586 38.8485 54.7232C42.7274 55.4393 48.516 55.9167 54.4239 53.47C65.5834 48.8749 63.6737 36.6413 73.2816 31.7479C82.8894 26.8545 89.8118 35.4478 104.015 33.4785C105.859 33.2229 107.676 32.8035 109.445 32.2253C102.569 24.8821 93.7889 19.5932 84.0829 16.9482C73.6993 23.632 67.6124 31.2108 57.4674 30.6737C53.6384 30.4715 49.9316 29.2565 46.7257 27.1528C44.9355 31.6285 41.5339 37.7155 35.2083 41.117C30.8519 43.3847 26.8536 43.5041 22.3779 43.2057C18.3341 50.6451 16.0779 58.9237 15.7879 67.3861C15.4978 75.8485 17.182 84.2623 20.707 91.961C22.3707 89.7496 24.2942 87.746 26.4359 85.9934Z",
    fill: "url(#paint6_linear_1944_97883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2083 41.1169C41.5339 37.7154 44.9355 31.6284 46.7258 27.1527C49.9316 29.2563 53.6384 30.4713 57.4674 30.6736C67.6124 31.2107 73.6993 23.6318 84.083 16.9481C79.4484 15.7206 74.6744 15.0988 69.8801 15.0982C60.1689 15.091 50.6347 17.6967 42.277 22.642C33.9194 27.5873 27.0461 34.69 22.3779 43.2056C26.8536 43.504 30.8519 43.3846 35.2083 41.1169Z",
    fill: "url(#paint7_linear_1944_97883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2083 41.1169C41.5339 37.7154 44.9355 31.6284 46.7258 27.1527C49.9316 29.2563 53.6384 30.4713 57.4674 30.6736C67.6124 31.2107 73.6993 23.6318 84.083 16.9481C79.4484 15.7206 74.6744 15.0988 69.8801 15.0982C60.1689 15.091 50.6347 17.6967 42.277 22.642C33.9194 27.5873 27.0461 34.69 22.3779 43.2056C26.8536 43.504 30.8519 43.3846 35.2083 41.1169Z",
    fill: "url(#paint8_linear_1944_97883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.851 130.69V128.005C104.851 126.517 104.26 125.09 103.208 124.039C102.156 122.987 100.729 122.396 99.2417 122.396H40.5205C39.0431 122.411 37.6316 123.009 36.5924 124.059C35.5533 125.11 34.9705 126.528 34.9706 128.005V130.69C34.9641 131.28 34.8072 131.858 34.5148 132.369C34.2223 132.881 33.8041 133.31 33.2997 133.615C32.3205 134.173 31.5065 134.981 30.9405 135.955C30.3745 136.93 30.0766 138.037 30.0771 139.164H109.745C109.745 138.037 109.447 136.93 108.881 135.955C108.315 134.981 107.501 134.173 106.522 133.615C106.005 133.324 105.577 132.898 105.283 132.383C104.989 131.868 104.84 131.283 104.851 130.69Z",
    fill: "url(#paint9_linear_1944_97883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.745 139.165C109.745 137.471 109.072 135.847 107.874 134.65C106.677 133.452 105.053 132.779 103.359 132.779H36.4028C34.7197 132.795 33.1108 133.475 31.9262 134.67C30.7416 135.866 30.0771 137.481 30.0771 139.165H109.745Z",
    fill: "url(#paint10_linear_1944_97883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.19 73.342C115.303 73.342 114.453 72.9899 113.827 72.3632C113.2 71.7365 112.848 70.8865 112.848 70.0002C112.848 58.4464 108.258 47.3658 100.088 39.1961C91.9186 31.0264 80.838 26.4366 69.2842 26.4366C68.3979 26.4366 67.5479 26.0846 66.9212 25.4578C66.2945 24.8311 65.9424 23.9811 65.9424 23.0948C65.9424 22.2085 66.2945 21.3585 66.9212 20.7317C67.5479 20.105 68.3979 19.7529 69.2842 19.7529C82.6058 19.7687 95.3772 25.0677 104.797 34.4874C114.217 43.9072 119.516 56.6786 119.531 70.0002C119.531 70.8865 119.179 71.7365 118.553 72.3632C117.926 72.9899 117.076 73.342 116.19 73.342Z",
    fill: "url(#paint11_linear_1944_97883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.066 10.4434C124.408 11.9267 125.16 13.284 126.236 14.3603C127.313 15.4367 128.67 16.1886 130.153 16.5303C128.667 16.8655 127.306 17.6152 126.229 18.6926C125.151 19.7701 124.402 21.1309 124.066 22.6173C123.745 21.1247 123 19.7565 121.92 18.6769C120.84 17.5973 119.472 16.8519 117.979 16.5303C119.466 16.1952 120.827 15.4454 121.904 14.368C122.982 13.2906 123.731 11.9297 124.066 10.4434Z",
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4576 107.417C12.2486 107.417 12.8898 106.775 12.8898 105.984C12.8898 105.193 12.2486 104.552 11.4576 104.552C10.6666 104.552 10.0254 105.193 10.0254 105.984C10.0254 106.775 10.6666 107.417 11.4576 107.417Z",
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9137 124.842C27.7047 124.842 28.3459 124.201 28.3459 123.41C28.3459 122.619 27.7047 121.978 26.9137 121.978C26.1227 121.978 25.4814 122.619 25.4814 123.41C25.4814 124.201 26.1227 124.842 26.9137 124.842Z",
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.312 16.5305C109.103 16.5305 109.744 15.8892 109.744 15.0982C109.744 14.3072 109.103 13.666 108.312 13.666C107.521 13.666 106.88 14.3072 106.88 15.0982C106.88 15.8892 107.521 16.5305 108.312 16.5305Z",
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.453 32.4635C127.772 32.4635 128.84 31.3948 128.84 30.0765C128.84 28.7582 127.772 27.6895 126.453 27.6895C125.135 27.6895 124.066 28.7582 124.066 30.0765C124.066 31.3948 125.135 32.4635 126.453 32.4635Z",
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6348 125.081C15.2997 123.594 14.5499 122.234 13.4725 121.156C12.3951 120.079 11.0342 119.329 9.54785 118.994C11.0358 118.641 12.3949 117.878 13.4709 116.791C14.5469 115.705 15.2966 114.338 15.6348 112.847C15.9665 114.341 16.7141 115.711 17.7911 116.799C18.8681 117.887 20.2308 118.648 21.7218 118.994C20.2292 119.315 18.861 120.061 17.7814 121.14C16.7017 122.22 15.9564 123.588 15.6348 125.081Z",
    fill: "#FFC400"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1944_97883",
    x1: "0.773525",
    y1: "60.1101",
    x2: "139.335",
    y2: "79.8304",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0065FF",
    stopOpacity: "0.5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.01",
    stopColor: "#0065FF",
    stopOpacity: "0.47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.08",
    stopColor: "#0065FF",
    stopOpacity: "0.33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.15",
    stopColor: "#0065FF",
    stopOpacity: "0.21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.22",
    stopColor: "#0065FF",
    stopOpacity: "0.12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.29",
    stopColor: "#0065FF",
    stopOpacity: "0.05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.38",
    stopColor: "#0065FF",
    stopOpacity: "0.01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.49",
    stopColor: "#0065FF",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.71",
    stopColor: "#0065FF",
    stopOpacity: "0.01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.79",
    stopColor: "#0065FF",
    stopOpacity: "0.03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.84",
    stopColor: "#0065FF",
    stopOpacity: "0.08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.89",
    stopColor: "#0065FF",
    stopOpacity: "0.15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.93",
    stopColor: "#0065FF",
    stopOpacity: "0.23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.96",
    stopColor: "#0065FF",
    stopOpacity: "0.34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.99",
    stopColor: "#0065FF",
    stopOpacity: "0.46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#0065FF",
    stopOpacity: "0.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1944_97883",
    x1: "28.1627",
    y1: "111.08",
    x2: "111.733",
    y2: "27.5095",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0065FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.06",
    stopColor: "#1C76FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.19",
    stopColor: "#4F95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.33",
    stopColor: "#7BAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.46",
    stopColor: "#9FC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.59",
    stopColor: "#BAD6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.73",
    stopColor: "#CEE1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.86",
    stopColor: "#DAE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#DEEBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1944_97883",
    x1: "31.592",
    y1: "107.548",
    x2: "108.204",
    y2: "30.9363",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.14",
    stopColor: "#3A7AD9",
    stopOpacity: "0.74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.46",
    stopColor: "#CBDEFB",
    stopOpacity: "0.08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.5",
    stopColor: "#DEEBFF",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.55",
    stopColor: "#BFD9FF",
    stopOpacity: "0.17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.64",
    stopColor: "#91C0FF",
    stopOpacity: "0.42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.72",
    stopColor: "#6BAAFF",
    stopOpacity: "0.63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.8",
    stopColor: "#4D9AFF",
    stopOpacity: "0.79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.87",
    stopColor: "#388EFF",
    stopOpacity: "0.9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.93",
    stopColor: "#2B87FF",
    stopOpacity: "0.97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.97",
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1944_97883",
    x1: "17.0371",
    y1: "70.4417",
    x2: "150.997",
    y2: "73.2422",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0065FF",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.16",
    stopColor: "#0065FF",
    stopOpacity: "0.01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.28",
    stopColor: "#0267FF",
    stopOpacity: "0.05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.38",
    stopColor: "#0468FF",
    stopOpacity: "0.11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.48",
    stopColor: "#086BFF",
    stopOpacity: "0.2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.57",
    stopColor: "#0C6FFF",
    stopOpacity: "0.32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.66",
    stopColor: "#1173FF",
    stopOpacity: "0.46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.74",
    stopColor: "#1878FF",
    stopOpacity: "0.63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.82",
    stopColor: "#1F7EFF",
    stopOpacity: "0.81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.89",
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1944_97883",
    x1: "1215.59",
    y1: "-13688.3",
    x2: "17886.5",
    y2: "-4099.29",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0065FF",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.16",
    stopColor: "#0065FF",
    stopOpacity: "0.01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.28",
    stopColor: "#0267FF",
    stopOpacity: "0.05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.38",
    stopColor: "#0468FF",
    stopOpacity: "0.11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.48",
    stopColor: "#086BFF",
    stopOpacity: "0.2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.57",
    stopColor: "#0C6FFF",
    stopOpacity: "0.32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.66",
    stopColor: "#1173FF",
    stopOpacity: "0.46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.74",
    stopColor: "#1878FF",
    stopOpacity: "0.63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.82",
    stopColor: "#1F7EFF",
    stopOpacity: "0.81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.89",
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1944_97883",
    x1: "77.7093",
    y1: "137.213",
    x2: "77.7093",
    y2: "39.9295",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0.33",
    stopColor: "#8777D9",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.47",
    stopColor: "#8777D9",
    stopOpacity: "0.2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.81",
    stopColor: "#8777D9",
    stopOpacity: "0.7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#8777D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1944_97883",
    x1: "9.47326",
    y1: "35.5702",
    x2: "109.071",
    y2: "72.6544",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0.15",
    stopColor: "#8777D9",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.22",
    stopColor: "#8777D9",
    stopOpacity: "0.06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.34",
    stopColor: "#8777D9",
    stopOpacity: "0.2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.5",
    stopColor: "#8777D9",
    stopOpacity: "0.44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.7",
    stopColor: "#8777D9",
    stopOpacity: "0.76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.83",
    stopColor: "#8777D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1944_97883",
    x1: "27872.3",
    y1: "24669",
    x2: "27872.3",
    y2: "19657.7",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0.15",
    stopColor: "#8777D9",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.22",
    stopColor: "#8777D9",
    stopOpacity: "0.06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.34",
    stopColor: "#8777D9",
    stopOpacity: "0.2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.5",
    stopColor: "#8777D9",
    stopOpacity: "0.44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.7",
    stopColor: "#8777D9",
    stopOpacity: "0.76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.83",
    stopColor: "#8777D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1944_97883",
    x1: "102.538",
    y1: "47.1032",
    x2: "-24.2287",
    y2: "3.70714",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B00",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.12",
    stopColor: "#FF8B00",
    stopOpacity: "0.01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.22",
    stopColor: "#FF8B00",
    stopOpacity: "0.05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.3",
    stopColor: "#FF8B00",
    stopOpacity: "0.11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.38",
    stopColor: "#FF8B00",
    stopOpacity: "0.2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.45",
    stopColor: "#FF8B00",
    stopOpacity: "0.32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.52",
    stopColor: "#FF8B00",
    stopOpacity: "0.46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.58",
    stopColor: "#FF8B00",
    stopOpacity: "0.63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.65",
    stopColor: "#FF8B00",
    stopOpacity: "0.81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.7",
    stopColor: "#FF8B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1944_97883",
    x1: "40.7055",
    y1: "116.517",
    x2: "102.285",
    y2: "152.066",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0.41",
    stopColor: "#FFAB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.48",
    stopColor: "#FFAE08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.58",
    stopColor: "#FFB61E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.7",
    stopColor: "#FFC441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.84",
    stopColor: "#FFD772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#FFF0B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1944_97883",
    x1: "30.0652",
    y1: "135.978",
    x2: "109.733",
    y2: "135.978",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF991F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.32",
    stopColor: "#FF9B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.5",
    stopColor: "#FFA12A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.65",
    stopColor: "#FFAC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.79",
    stopColor: "#FFBB4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.9",
    stopColor: "#FFCF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#FFE380"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1944_97883",
    x1: "124.604",
    y1: "56.6089",
    x2: "61.8486",
    y2: "33.7649",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0.1",
    stopColor: "#E6FCFF",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.45",
    stopColor: "#E6FCFF",
    stopOpacity: "0.5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.91",
    stopColor: "#E6FCFF",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1944_97883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "140",
    height: "140",
    fill: "white"
  }))));
};